module.exports = __webpack_public_path__ + "static/apizoom_example_result_small-ca3530d719955a7d3fc4d9afa8efed33.jpeg";